var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodejs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4000 1392",
    width: 1000,
    height: 348,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    stroke: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2015,241)",
    d: "m0 0 5 1 16 8 24 14 28 16 24 14 26 15 11 7 7 6 4 7v638l-3 6-7 7-16 10-17 10-28 17-29 17-28 17-17 10-75 45h-2l1 3-9 2h-18l3-4-25-15-22-13-25-15-28-17-26-15-13-8-15-9-32-19-21-13-10-8-4-7-1-4v-262l4-8 9-8 21-13 22-13 28-17 29-17 28-17 29-17 45-27 12-6 3-1h8l16 8 20 12 23 14 8 3v-2l5-1 1-339 4-8zm-91 501-18 11-17 10-26 16-12 7-2 2v92l9 6 26 15 18 11 15 9 8 5 5-2 22-13 50-30 1-1 1-89-2-4-21-13-25-15-29-17z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1303,552)",
    d: "m0 0 9 3 18 10 50 30 22 13 45 27 28 17 16 9 16 10 18 11 7 6 4 6 1 3v264l-4 8-7 7-28 17-29 17-28 17-22 13-40 24-32 19-13 8-15 9-12 5 2 1-1 4h-9v-2h3v-3l-6-1-14-7-23-14-25-15-32-19-28-17-22-13-25-15-28-17-15-9-9-7-4-7-1-6v-262l3-6 10-9 23-14 32-19 15-9 32-19 45-27 32-19 16-10 17-9z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(677,551)",
    d: "m0 0h6l16 8 45 27 32 19 35 21 27 16 15 9 32 19 17 11 8 7 2 4 1 7v81l-1 262-6 7-4 2-7-1-24-14-22-13-59-35-21-13-9-8-3-7-1-13-1-158-4-8-7-6-24-15-26-15-11-5-5-1-10 4-20 11-28 17-13 10-3 6-1 22-1 151-5 8-9 8-22 13-25 15-29 17-40 24-10 5-6 1-8-7-1-1-1-10v-337l3-8 7-7 19-12 32-19 15-9 59-35 25-15 17-10 28-17 16-9z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2549,554)",
    d: "m0 0 11 4 18 10 23 14 40 24 28 17 17 10 28 17 32 19 19 12 9 7 6 8 1 3v73l-3 8-7 8-26 16-22 13-35 21-28 17-19 11h-8l-6-4-2-2-1-4-1-69-5-5-22-14-41-24-8-4-7 3-16 9-22 13-30 19-1 1-1 27v57l2 8 21 13 24 14 20 12 29 17 30 18 39 23 20 12 22 13 11 8 4 6v7l-7 8-13 8-23 13-26 15-14 8-24 14-22 13-14 5-9-1-12-6-25-15-22-13-27-16-29-17-51-30-22-13-20-12-13-10-3-6-1-5v-261l3-7 5-6 17-11 32-19 45-27 32-19 80-48 12-6z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(3165,549)",
    d: "m0 0h15l12 5 16 9 13 8 15 9 32 19 28 17 22 13 28 17 29 17 16 10 10 9 7 12 2 6v251l-4 13-8 11-10 8-29 17-40 24-32 19-25 15-17 10-15 9-23 14-15 9-15 5h-11l-12-4-16-9-22-14-23-14-11-7-4-5 15-7 16-8 4-3 6 1 17 10 33 21 7-1 15-9 32-19 50-30 32-19 45-27 22-13 1-242-5-2-21-13-22-13-32-19-40-24-32-19-23-14-24-14-7 1-13 8-45 27-22 13-15 9-32 19-40 24-28 17v242l24 14 20 12 16 9 8 3h13l10-5 7-8 2-7 1-35v-206l4-2h31l2 1v248l-2 14-5 12-8 11-8 7-12 6-14 3h-22l-13-3-25-12-45-27-10-8-7-10-4-9-1-5-1-45 1-204 3-10 7-11 8-7 17-11 22-13 15-9 32-19 28-17 22-13 28-17 22-13 14-8 10-4z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(3219,717)",
    d: "m0 0h12l26 2 17 4 12 5 14 9 8 8 7 11 5 12 3 16v9l-2 2-7 1h-23l-5-3-6-17-6-9-11-7-11-3-18-2h-18l-18 2-11 4-6 5-4 7-1 4v10l3 6 12 6 31 6 42 7 22 5 14 5 12 7 8 7 8 14 3 11v23l-4 14-7 13-9 10-13 9-16 7-19 4-19 2h-24l-28-3-15-4-17-8-11-8v-2l-4-2-9-13-5-12-2-9-1-17 2-3 4-1h29l3 5 5 17 6 9 8 6 10 4 10 2 11 1h32l16-2 12-4 9-7 5-10v-13l-3-6-5-4-15-5-25-5-49-7-17-4-14-6-11-8-8-9-5-10-3-11v-20l3-12 7-14 11-12 11-7 10-5 14-4 11-2z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2546,776)",
    d: "m0 0 5 1 25 14 14 9 3 3v54l-14 8-13 8-16 10-5-1-21-12-19-12-2-2v-53l4-4 17-10 20-12z",
    fill: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(3499,579)",
    d: "m0 0h16l12 4 9 7 9 13 3 9v13l-3 10-8 11-9 8-9 4-4 1h-13l-9-2-10-6-8-9-5-10-2-9v-9l2-8 5-10 9-10 8-5zm1 8-10 5-8 9-4 9-1 6v8l3 10 6 8 8 6 6 2 9 1 12-3 9-7 6-9 1-3v-19l-4-10-8-8-10-5z",
    fill: "current"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(3505,595)",
    d: "m0 0 13 2 5 5v11l-1 10 1 4v11l-3 3h-5l-2-4-2-13h-9v13l-2 5-5-2-2-3-1-7v-22l2-10 3-2zm-2 9-2 5 1 6h9l2-1-1-8-5-2z",
    fill: "current"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(3179,1106)",
    d: "m0 0h2v3l-2 1h-13l-3-3h13z",
    fill: "current"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2546,1106)",
    d: "m0 0 4 2-1 3-3-1z",
    fill: "current"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(3502,637)",
    d: "m0 0",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejs);
export default __webpack_public_path__ + "static/media/nodejs.247e5028ecf84ae7f5a7f090091aef7f.svg";
export { ForwardRef as ReactComponent };